// import React, { useState, useEffect } from 'react';
// import { AuthProvider, useAuth, Onboarding } from './auth';
// import { HomeFeed } from './HomeFeed';
// import { ProfilePage } from './ProfilePage';
// import Settings from './components/Settings';

// // ==================== MAIN APP ====================
// export default function App() {
//   useEffect(() => {
//     // Add meta tag for safe area insets if not already present
//     const viewport = document.querySelector('meta[name="viewport"]');
//     if (viewport) {
//       viewport.setAttribute('content', 
//         'width=device-width, initial-scale=1.0, viewport-fit=cover, user-scalable=no'
//       );
//     }
//   }, []);

//   return (
//     <AuthProvider>
//       <AppContent />
//     </AuthProvider>
//   );
// }

// function AppContent() {
//   const { user, loading } = useAuth();
//   const [currentPage, setCurrentPage] = useState('profile'); // 'profile', 'home', or 'settings'
//   const [profileUsername, setProfileUsername] = useState(null); // Username to show in profile page
//   const [previousPage, setPreviousPage] = useState(null); // Track previous page for back navigation

//   if (loading) {
//     return (
//       <div style={{
//         minHeight: '100vh',
//         background: '#e6c57e',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         paddingTop: 'env(safe-area-inset-top)',
//         paddingBottom: 'env(safe-area-inset-bottom)',
//         paddingLeft: 'env(safe-area-inset-left)',
//         paddingRight: 'env(safe-area-inset-right)'
//       }}>
//         <div style={{
//           color: '#553918',
//           fontSize: '0.85em',
//           letterSpacing: '0.15em',
//           textTransform: 'uppercase',
//           fontWeight: 300
//         }}>
//           Loading...
//         </div>
//       </div>
//     );
//   }

//   if (user) {
//     if (currentPage === 'home') {
//       return <HomeFeed 
//         onNavigateToProfile={(username) => {
//           // Track that we're coming from home feed
//           setPreviousPage('home');
//           if (username) {
//             setProfileUsername(username);
//           } else {
//             setProfileUsername(null);
//           }
//           setCurrentPage('profile');
//         }} 
//       />;
//     }
//     if (currentPage === 'settings') {
//       return <Settings onBack={() => setCurrentPage('profile')} />;
//     }
//     return <ProfilePage 
//       onNavigateToHome={() => {
//         setProfileUsername(null);
//         setPreviousPage(null);
//         setCurrentPage('home');
//       }} 
//       onNavigateToSettings={() => {
//         setPreviousPage('profile');
//         setCurrentPage('settings');
//       }}
//       initialUsername={profileUsername}
//       onProfileLoaded={() => setProfileUsername(null)}
//       previousPage={previousPage}
//       onBack={() => {
//         // Handle back navigation based on previous page
//         if (previousPage === 'home') {
//           // Return to home feed
//           setProfileUsername(null);
//           setPreviousPage(null);
//           setCurrentPage('home');
//         } else {
//           // If no previous page or came from profile search, just clear the search
//           // This will show own profile
//           setProfileUsername(null);
//         }
//       }}
//     />;
//   }

//   return <Onboarding />;
// }


import React, { useState, useEffect } from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth, Onboarding } from './auth';
import { HomeFeed } from './HomeFeed';
import { ProfilePage } from './ProfilePage';
import Settings from './components/Settings';
import { GuestProfileView } from './components/GuestProfileView';

// ==================== MAIN APP ====================
export default function App() {
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 
        'width=device-width, initial-scale=1.0, viewport-fit=cover, user-scalable=no'
      );
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

function AppContent() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState('profile'); 
  const [profileUsername, setProfileUsername] = useState(null); 
  const [previousPage, setPreviousPage] = useState(null); 

  // Check if URL is a username route (e.g., /username)
  const pathname = location.pathname;
  const pathParts = pathname.split('/').filter(Boolean); // Remove empty strings
  const isUsernameRoute = pathParts.length === 1 && pathParts[0] && 
    !['home', 'settings', 'profile'].includes(pathParts[0].toLowerCase());
  const urlUsername = isUsernameRoute ? pathParts[0] : null;

  // OPTIMIZATION: For username routes, show guest profile immediately (don't wait for auth)
  // Guest profiles work for both logged in and logged out users, so no auth needed
  if (urlUsername) {
    return (
      <GuestProfileView 
        username={urlUsername} 
        onBack={() => navigate('/')} 
      />
    );
  }

  // LOADING STATE (only for non-username routes that need auth)
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: '#e6c57e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)'
      }}>
        <div style={{
          color: '#553918',
          fontSize: '0.85em',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          fontWeight: 300
        }}>
          Loading...
        </div>
      </div>
    );
  }

  // LOGGED IN STATE
  if (user) {
    return (
      <>
        {/* RECRUITER POPUP OVERLAY */}
        {/* <DevPopup /> */}

        {currentPage === 'home' && (
          <HomeFeed 
            onNavigateToProfile={(username) => {
              setPreviousPage('home');
              setProfileUsername(username || null);
              setCurrentPage('profile');
            }} 
          />
        )}

        {currentPage === 'settings' && (
          <Settings onBack={() => setCurrentPage('profile')} />
        )}

        {currentPage === 'profile' && (
          <ProfilePage 
            onNavigateToHome={() => {
              setProfileUsername(null);
              setPreviousPage(null);
              setCurrentPage('home');
            }} 
            onNavigateToSettings={() => {
              setPreviousPage('profile');
              setCurrentPage('settings');
            }}
            initialUsername={profileUsername}
            onProfileLoaded={() => setProfileUsername(null)}
            previousPage={previousPage}
            onBack={() => {
              if (previousPage === 'home') {
                setProfileUsername(null);
                setPreviousPage(null);
                setCurrentPage('home');
              } else {
                setProfileUsername(null);
              }
            }}
          />
        )}
      </>
    );
  }

  // LOGGED OUT / ONBOARDING STATE
  return (
    <>
      {/* <DevPopup /> */}
      <Onboarding />
    </>
  );
}

// // ==================== NEW PREMIUM RED GLASS POPUP ====================
// function DevPopup() {
//   const [isOpen, setIsOpen] = useState(true);

//   if (!isOpen) return null;

//   // Inline styles for the "glass-on-glass" tech stack container
//   const innerGlassStyle = {
//     background: 'rgba(255, 255, 255, 0.1)', // Slightly lighter frost
//     borderRadius: '16px',
//     padding: '16px',
//     marginBottom: '24px',
//     border: '1px solid rgba(255, 255, 255, 0.15)', // Very subtle edge
//     boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.1)', // Inner light catch
//   };

//   const techItemStyle = {
//     margin: '4px 0',
//     fontSize: '13px',
//     fontWeight: '500',
//     color: 'rgba(255, 255, 255, 0.9)',
//     letterSpacing: '0.3px',
//   };

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       zIndex: 9999,
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '24px',
//       // Darker, heavier blur on the actual app background for contrast
//       background: 'rgba(0, 0, 0, 0.3)', 
//       backdropFilter: 'blur(8px)', 
//       WebkitBackdropFilter: 'blur(8px)',
//       animation: 'fadeIn 0.4s ease-out'
//     }}>
//       <div style={{
//         position: 'relative',
//         width: '100%',
//         maxWidth: '360px', // Slightly narrower for elegance
        
//         // === THE ULTRA-PREMIUM APPLE RED GLASS ===
//         // 1. Gradient base for depth (light top-left to deeper bottom-right)
//         background: 'linear-gradient(135deg, rgba(220, 50, 70, 0.65) 0%, rgba(170, 20, 40, 0.85) 100%)',
        
//         // 2. Intense blur and saturation for that "jelly" look
//         backdropFilter: 'blur(30px) saturate(200%)',
//         WebkitBackdropFilter: 'blur(30px) saturate(200%)',
        
//         // 3. The "Sexy Edges" - Inner highlights to fake glass thickness
//         border: '1px solid rgba(255, 255, 255, 0.25)',
//         boxShadow: `
//           inset 0 1px 2px rgba(255, 255, 255, 0.3), /* Top inner light */
//           inset 0 -1px 2px rgba(0, 0, 0, 0.1),    /* Bottom inner shadow */
//           0 25px 50px -12px rgba(0, 0, 0, 0.5)     /* Deep drop shadow */
//         `,
        
//         borderRadius: '32px', // Larger, smoother corners
//         padding: '36px 28px',
//         color: 'white',
//         fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
//         textAlign: 'center',
//         overflow: 'hidden' // Ensures the inner sheen stays contained
//       }}>
        
//         {/* Subtle top sheen reflection underneath the title */}
//         <div style={{
//             position: 'absolute', top: 0, left: 0, right: 0, height: '40%',
//             background: 'linear-gradient(to bottom, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 100%)',
//             pointerEvents: 'none'
//         }}></div>

//         {/* CLOSE BUTTON - Cleaner, integrated look */}
//         <button 
//           onClick={() => setIsOpen(false)}
//           style={{
//             position: 'absolute',
//             top: '20px',
//             right: '20px',
//             background: 'rgba(0, 0, 0, 0.15)', // Darker, subtle button background
//             border: 'none',
//             borderRadius: '50%',
//             width: '32px',
//             height: '32px',
//             color: 'rgba(255, 255, 255, 0.9)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             cursor: 'pointer',
//             fontSize: '15px',
//             backdropFilter: 'blur(10px)',
//             border: '1px solid rgba(255,255,255,0.1)',
//             zIndex: 2
//           }}
//         >
//           ✕
//         </button>

//         {/* CONTENT */}
//         <div style={{ position: 'relative', zIndex: 1 }}>
//             <h2 style={{ 
//               margin: '0 0 16px 0', 
//               fontSize: '24px', 
//               fontWeight: '700',
//               letterSpacing: '-0.5px',
//               textShadow: '0 2px 10px rgba(0,0,0,0.1)' // Subtle lift
//             }}>
//               under development!
//             </h2>
            
//             <p style={{ 
//               fontSize: '16px', 
//               lineHeight: '1.5', 
//               color: 'rgba(255, 255, 255, 0.9)', // Slightly softer white for elegance
//               marginBottom: '28px',
//               fontWeight: '400'
//             }}>
//               Hi! I'm still building this. Look around, try logging in, and let me know what you think! <br/>
//               Make an account and search for me -  <br /> @ amishabansal
//             </p>

//             {/* CLEANER "GLASS-ON-GLASS" TECH STACK */}
//             <div style={innerGlassStyle}>
//               <p style={{
//                 fontSize: '11px',
//                 textTransform: 'uppercase',
//                 letterSpacing: '1.5px',
//                 color: 'rgba(255, 255, 255, 0.6)',
//                 margin: '0 0 12px 0',
//                 fontWeight: '700'
//               }}>Core Tech Stack</p>
              
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
//                 <span style={techItemStyle}>React 19 & Context API</span>
//                 <span style={techItemStyle}>Supabase (PostgreSQL, Auth, Edge Functions)</span>
//                 <span style={techItemStyle}>OpenAI Moderation API (AI Safety)</span>
//                 <span style={techItemStyle}>Capacitor (iOS/Android) & PWA</span>
//               </div>
//             </div>

//             <a 
//               href="mailto:amishabansal21@gmail.com"
//               style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: 'white',
//                 textDecoration: 'none',
//                 fontSize: '14px',
//                 fontWeight: '600',
//                 // A brighter glass button that pops slightly
//                 background: 'rgba(255, 255, 255, 0.25)',
//                 padding: '12px 24px',
//                 borderRadius: '100px', // Full lozenge shape
//                 border: '1px solid rgba(255, 255, 255, 0.4)',
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                 transition: 'all 0.2s ease'
//               }}
//             >
//               amishabansal21@gmail.com
//             </a>
//         </div>
//       </div>
//     </div>
//   );
// }